export interface ApiError {
  code: number
  message: string
  details?: string
  payload?: unknown
}

export class ApiException extends Error {
  code: number
  details?: string
  payload?: unknown

  constructor(error: ApiError) {
    super(error.message)
    this.name = "ApiException"
    this.code = error.code
    this.details = error.details
    this.payload = error.payload
  }
}

export function isNotFoundError(error: unknown): error is ApiException {
  return error instanceof ApiException && error.code === 404
}

export interface MutationResult<T> {
  data: T | null
  error: ApiException | null
}

export interface BulkOperationResult {
  succeeded: number
  failed: number
  failedIds: string[]
}
